import { DriveFileMoveOutlined } from '@mui/icons-material'
import { CreativeUploadFolder, useCreativeUploadPage } from './_main'
import { FileAction, FileState } from 'components/common/FileAPI'
import { Grid, Stack, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import { CreativeUploadImageItem } from './CreativeUploadImageItem.comonent'
import { FC } from 'react'
import { FileAPIUpload } from 'components/common/FileAPIUpload'
import { MUIButton } from 'components/common/MUIButton'
import { MUITooltip } from 'components/common/MUITooltip'
import { SectionedBorderBox } from 'components/common/SectionedBorderBox'
import { SystemMessage } from 'components/common/SystemMessage'

/** Additional visual upload controller */
export const AdditionalVisualsUpload: FC = () => {
  const { t } = useTranslation(['ct_upload_page'])
  const {
    fileCtrl,
    gridItemSize,
    droppedRequiredVisualsAmount,
    requiredVisualAmount,
    additionalVisualsForDisplay,
    imagesForPopupPreview,
    timerCtrl,
    logTimedUpload,
    setExpandedImageIndex,
  } = useCreativeUploadPage()

  return (
    <SectionedBorderBox
      title={
        <Typography variant="h3" fontWeight={500} lineHeight="normal" mb=".5rem">
          {t('additional_upload.title')}
        </Typography>
      }
      position="relative"
      p={2}
    >
      <Stack gap={2}>

        <SystemMessage
          sx={{ width: '100%' }}
          message={(
            <Typography fontSize="1.4rem" component="span">
              <Trans
                t={t}
                i18nKey="additional_upload.info_message"
                components={{
                  list: <ul style={{ padding: '0 2rem' }} />,
                  item: <li />,
                }}
              >
                &nbsp;
              </Trans>
            </Typography>
          )}
        />

        <FileAPIUpload
          showFileListing={false}
          dropzoneText={
            <Trans t={t} i18nKey="dropbox_text">
              &nbsp;
            </Trans>
          }
          acceptedFileTypes="any"
          files={additionalVisualsForDisplay}
          onCheckFileSize={(size) => size > 0}
          uploadHandler={(acceptedFiles) => {
            const startedDuringOtherUpload = fileCtrl.isAnyUploadRunning
            const timer = timerCtrl.startEventTimer()

            fileCtrl.uploadFiles(acceptedFiles, {
              tag: CreativeUploadFolder.ADDITIONAL_VISUALS,
              onSettled: () => {
                timer.stopTimer()
                logTimedUpload(acceptedFiles, CreativeUploadFolder.ADDITIONAL_VISUALS, timer.delta!, startedDuringOtherUpload)
              },
            })
          }}
        />

        <Grid container spacing={1}>
          {!!additionalVisualsForDisplay.length && additionalVisualsForDisplay.map((file) => (
            <Grid item key={file.id} xs={gridItemSize}>
              <CreativeUploadImageItem
                onClick={() => {
                  const index = imagesForPopupPreview.findIndex(entry => entry.id === file.id)

                  if (index >= 0) setExpandedImageIndex(index)
                }}
                file={file}

                fileCtrl={fileCtrl}
                config={{ allowDelete: true, allowRetry: true }}
                leftActionsSlot={droppedRequiredVisualsAmount < requiredVisualAmount && file.action === FileAction.LOAD && file.state !== FileState.RUNNING &&
                  <MUITooltip content={t('additional_upload.move_to_required')}>
                    <MUIButton
                      size="sm"
                      isIconButton
                      onClick={(e) => {
                        e.stopPropagation()
                        fileCtrl.editFile(file.id, { tag: CreativeUploadFolder.REQUIRED_VISUALS })
                      }}
                    >
                      <DriveFileMoveOutlined fontSize="large" />
                    </MUIButton>
                  </MUITooltip>
                }
              />
            </Grid>
          ))}
        </Grid>

      </Stack>
    </SectionedBorderBox>
  )
}
